import "./ui/base.css";
import { Game } from "./game/Game";

new Game();
